import { sgiArray, deepCopyAll } from 'rt-sd-common/sgiCommon/sgiCommon'
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
/**
 * 树控件的基础方法，供树控件继承
 * wangz
 * 2018.3.12
 */

"use strict"
/**
 * 树实例方法集
 * @namespace 树实例方法集
 * @alias tree
 * @inst
 */
var sgiTreeBaseFun = {

	/**
	 * 刷新树方法
	 * @param {Array} treeData 树上的数据数组
	 */
	refreshTree: function (treeData) {
		if (treeData) {
			this.state.treeData = treeData;
			this.createTreeStore();
			this.setState({ loading: true });
		}
	},

    /**
     * 设置树是否可勾选接口
     * @param {boolean} checkable 是否可勾选
     */
	setCheckable: function (checkable) {
		this.state.checkable = checkable;
		// this.state.multiple = checkable;
		this.setState({});
	},

    /**
    * 获取已选中/勾选节点
    */
	getSelection: function () {
		if (this.props.moduleDesc.ndIsChk) {
			return this.state.checkedNodes;
		} else {
			return this.state.selectedNodes;
		}
	},
    /**
     * 根据数据 设置选中
     */
	setTreeChecked: function (records) {
		if (!records) {
			return;
		}
		if (records instanceof Array) {
			this.state.checkedKeys = [];
			records.forEach(element => {
				this.state.checkedKeys.push(element[this.state.key]);
			});
		} else {
			this.state.checkedKeys = [records[this.state.key]];
		}

		//check的信息放入到 checknodes中
		this.state.checkedNodes = [];
		this.state.checkedKeys.forEach(element => {
			this.state.checkedNodes.push(this.state.keysTreeNode[element].props.itemData);
		});
		this.setState({ loading: false })
	},

    /**
     * 获取树的勾选数据(树结构json数据)
     */
	getCheckData: function () {
		const key = this.state.key;
		const cldKey = this.state.childrenName;
		const checkedNodes = this.state.checkedNodes || [];
		const checkKeys = checkedNodes.map(item => item[key]);
		const treeData = this.state.treeData || [];
		const getCheckItem = (item) => {
			if (!item) return null;
			if (checkKeys.indexOf(item[key]) !== -1) {
				return deepCopyAll(item, true);
			} else if (item[cldKey]) {
				let checkClds = [];
				item[cldKey].forEach(cld => {
					const checkCld = getCheckItem(cld);
					if (checkCld && checkCld[key]) {
						checkClds.push(checkCld);
					}
				});
				if (checkClds.length > 0) {
					let newItem = { ...item };
					newItem[cldKey] = checkClds;
					return newItem;
				}
			}
		}
		return treeData.map(data => getCheckItem(data)).filter(d => d);
	},

    /**
     * 设置树的勾选数据(树结构json数据)
     * @param {*} checkData 树结构勾选数据
     * @param {*} key 
     * @param {*} treeData 
     */
	setCheckData: function (checkData, key, treeData) {
		if (!Array.isArray(checkData)) return;
		treeData = this.state.treeData = treeData || this.state.treeData || [];
		key = key || this.state.key;
		const cldKey = this.state.childrenName;
		const setCheckItem = (item, treeItem) => {
			if (!item || !treeItem || item[key] !== treeItem[key]) return null;
			if (!item[cldKey]) {
				treeItem.checked = true;
			} else {
				item[cldKey].forEach(cld => {
					let treeCld;
					for (const trCld of treeItem[cldKey]) {
						if (cld[key] === trCld[key]) {
							treeCld = trCld;
							break;
						}
					}
					if (treeCld) {
						setCheckItem(cld, treeCld);
					}
				});
			}
		}
		checkData.forEach(check => {
			for (const data of treeData) {
				if (!check[key]) sgiLogger.warn(`设置树勾选，当前勾选节点的key=${key}的属性不存在，当前节点：`, check);
				if (check[key] === data[key]) {
					setCheckItem(check, data);
					break;
				}
			}
		});
		this.state.checkedKeys = [];
		this.createTreeStore();
		this.setState({});
	},

    /**
     * 根据普通数据 和对比属性，返回
     */
	getTreeRecord: function (records, key) {
		let rsList = [];
		if (!records || !key) {
			return rsList;
		}
		let inList;
		let tmpTreeRecord;

		if (records instanceof Array) {
			inList = records;
		} else {
			inList = [records];
		}

		inList.forEach(inElement => {
			if (!inElement) return;
			for (var index in this.state.keysTreeNode) {
				tmpTreeRecord = this.state.keysTreeNode[index].props.itemData;
				if (tmpTreeRecord[key] == inElement[key]) {
					rsList.push(tmpTreeRecord);
					break;
				}
			}
		});
		return rsList;
	},
    /**
     * 将树节点数据转换为结构
     * @param {*} info  树节点数据
     * @returns  树节点结构
     */
	cvtNode: function (info) {
		if (!info) {
			return;
		}
		let node = this.state.keysTreeNode[info[this.state.key]];
		if (node) {
			return node.props;
		}
	},

    /**
    * 选中树的某个节点
    * @param {info} info要选中的节点数据信息，含有key值
    */
	select: function (info) {
		if (!info || !info[this.state.key]) {
			return;
		}
		var e = {
			event: "select",
			selected: true,
			node: this.state.keysTreeNode[info[this.state.key]],
			selectedNodes: [this.state.keysTreeNode[info[this.state.key]]]
		};
		//自动展开父节点
		this.expand(info);
		
		this.state.treeProps.onSelect([info[this.state.key]], e);
	},

    /**
    * 展开树的某个节点
    * @param {object} record 要展开的树节点数据信息，含有key值
    */
	expand: function (record) {
		if (!record || !record[this.state.key]) {
			return;
		}
		this.state.expandedKeys = [...this.state.expandedKeys, record[this.state.key]].filter((d, index, arr) => (arr.indexOf(d) === index));
		//获取父节点 自动展开父节点
		let recordNode = this.cvtNode(record);
		while (recordNode.gainParent()) {
			recordNode = recordNode.gainParent()
			this.state.expandedKeys.push(recordNode.getData()[this.state.key]);
		}
		// this.setState({ loading: false });
		this.setState({});
	},
    /**
   * 节点全部展开
   * @param {treeNode} this要展开的节点
   */
	expandAll: function () {
		let keys = [];
		for (let key in this.state.keysTreeNode) {
			keys.push(key);
		}
		// this.tree.state.expandedKeys = keys;
		this.setState({ expandedKeys: keys });
	},
    /**
    * 选中首行
    */
	selFirst: function () {
		var treeData = this.state.treeData;
		if (treeData) {
			this.select(treeData[0]);
		}
	},

    /**
    * 删除树的选中数据
    */
	delTreeSel: function () {
		// var selectedNodes = this.state.selectedNodes;
		var selectedNodes = this.props.moduleDesc.ndIsChk ? this.state.checkedNodes : this.state.selectedNodes;
		var treeData = this.state.treeData;
		if (treeData && selectedNodes) {
			selectedNodes.map((item, index) => {
				//获取当前节点的父节点
				this.delTreeNode(item);
			});
			this.state.selectedKeys = [];//既然删除了那就置空喽
			this.state.selectedNodes = [];
			this.createTreeStore();
			this.setState({ loading: false });
		} else {
			return null;
		}
	},
    /**
     * 删除树的一个节点
     * @param  {[object]} node [节点数据信息]
     * @return {[type]}      [description]
     */
	delTreeNode: function (record) {

		//获取父pkey
		//先获取父treenode
		let NodeObj = this.state.keysTreeNode[record[this.state.key]];
		let parentNodeObj = NodeObj.props.parentNode;
		let parentNodeKey = parentNodeObj ? parentNodeObj.props.itemData[this.state.key] : undefined;
		let parentNode = this.findNodeByKey(null, parentNodeKey);
		let children;
		if (parentNode) {
			children = parentNode[this.state.childrenName]
		} else {
			children = this.state.treeData;
		}
		sgiArray.remove(children, record);
	}
	// eq: function (a, b) {
	//     //获取a和b的属性长度
	//     var propsA = Object.getOwnPropertyNames(a),
	//         propsB = Object.getOwnPropertyNames(b);
	//     if (propsA.length != propsB.length) {
	//         return false;
	//     }
	//     for (var i = 0; i < propsA.length; i++) {
	//         var propName = propsA[i];
	//         //如果对应属性对应值不相等，则返回false
	//         if (a[propName] !== b[propName]) {
	//             return false;
	//         }
	//     }
	//     return true;
	// },
	// /**
	//  * 删除树的一个节点
	//  * @param  {[object]} node [节点数据信息]
	//  * @return {[Array]}      [删除后的treeData]
	//  */
	// delTreeNode: function (node) {
	//     var treeData = this.state.treeData;
	//     var func1 = function (treeData, node, me) {
	//         var have = null;
	//         var i = 0;
	//         for (; i < treeData.length; i++) {
	//             have = (treeData[i] == node) || me.eq(treeData[i], node);
	//             if (have == true) {//找到此节点，然后删除
	//                 treeData.splice(i, 1);
	//                 break;
	//             } else if (have == false) {
	//                 continue;
	//             }
	//         }

	//         if (have == true) {
	//             return have;
	//         } else if (have == false) {//未找到，遍历查找子节点
	//             for (var j = 0; j < treeData.length; j++) {
	//                 var item = treeData[j];
	//                 if (item.cldSet && item.cldSet.length > 0) {
	//                     have = func1(item.cldSet, node, me);
	//                 }
	//                 if (have == true) {
	//                     break;
	//                 }
	//             }
	//             return have;
	//         }
	//     }

	//     if (treeData && node) {
	//         func1(treeData, node, this);
	//         this.refreshTree(treeData);
	//         return treeData;
	//     } else {
	//         return null;
	//     }
	// },

}




/**
 * treeNode树节点操作方法
 * @namespace treeNode方法集【注意：该方法集非全局方法集，须在树事件中使用】
 * @alias treeNode
 * @inst
 */
var sgiTreeNodeFun = {

    /**
    * 判断节点是否是根节点
	* @returns {boolean} 是否是根节点
    */
	isRoot: function () {
		if (this && this.parentNode) {
			return false;
		} else {
			return true;
		}
	},
    /**
     * 获取得父节点treeNode
     * @return {treeNode} 父节点treeNode对象
     */
	gainParent: function () {
		if (!this.parentNode) {
			return undefined;
		}
		return this.parentNode.props;
	},
	/**
	 * 获取treeNode上数据对象
	 * @returns {object} treeNode对应数据
	 */
	getData: function () {
		return this.itemData;
	},
    /**
    * 获取树的子节点treeNode数组
    * @return {treeNode[]} 子节点treeNode数组
    */
	gainChild: function () {
		if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
			// return this.itemData[this.tree.state.childrenName];
			let children = this.itemData[this.tree.state.childrenName];
			let childrenNode = [];
			if (children && children.length > 0) {
				children.forEach(element => {
					childrenNode.push(this.tree.state.keysTreeNode[element[this.tree.state.key]]);
				});
			}
			return childrenNode;
		} else {
			return null;
		}
	},
    /**
    * 获取树的子节点数据数组
    * @return {object[]} 子节点数据数组
    */
	gainChildData: function () {
		if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
			return this.itemData[this.tree.state.childrenName];
		} else {
			return null;
		}
	},

    /**
    * 取得根节点treeNode对象
	* @returns {treeNode} 根节点treeNode对象
    */
	gainRoot: function () {
		var p;
		var p2 = this;
		var findRoot = function () {
			p = p2.parentNode;
			if (p != null) {
				while (p.props != null) {
					p2 = p.props;
					return findRoot();
				}
			} else {//p=null
				return p2;
			}
		}
		p2 = findRoot();
		// let NodeObj = this.tree.state.keysTreeNode[p2[this.tree.state.key]];
		return p2;
	},
    /**
    * 节点是否有下级节点
	* @returns {boolean} 是否有下级
    */
	hasChild: function () {
		if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
			return true;
		} else {
			return false;
		}
	},
    /**
     * 判断是否是叶子节点
     * @return {boolean} true:是叶子节点，false:不是叶子节点
     */
	leaf: function () {
		if (this.isLeaf == true) {
			return true;
		} else {
			return false;
		}
	},

    /**
     * 在当前节点下添加子节点
     * @param  {object} record 要添加的节点数据
     */
	appendChild: function (record) {
		if (!record) {
			return;
		}
		delete record._key;
		delete record._pkey;
		if (this.itemData[this.tree.state.childrenName]) {
			this.itemData[this.tree.state.childrenName].push(record);
		} else {
			this.itemData[this.tree.state.childrenName] = [];
			this.itemData[this.tree.state.childrenName].push(record);
		}
		// this.tree.refresh();
		this.tree.createTreeStore();
		this.tree.setState({ loading: true });
	},
    /**
     * 移除当前树节点（非根节点）
     */
	remove: function () {
		var me = this.itemData;
		var children;
		if (this && this.parentNode && this.parentNode.props.itemData) {
			children = this.parentNode.props.itemData[this.tree.state.childrenName];
		} else {
			children = this.tree.state.treeData;
		}
		sgiArray.remove(children, me);
		// this.tree.refresh();
		this.tree.createTreeStore();
		this.tree.setState({ loading: true });
	},
    /**
     * 删除此节点下全部子节点
     */
	removeAllChild: function () {
		this.itemData[this.tree.state.childrenName] = [];
		// this.tree.refresh();
		this.tree.createTreeStore();
		this.tree.setState({ loading: true });
	},
    /**
     * 查找属性等于指定值的第一个子项
     * @param  {String} attribute 属性key
     * @param  {Object} value 匹配的属性值
     * @param  {Boolean} [deep=false] 是否递归遍历，true表示遍历所有子节点，false表示只遍历下一级
     * @return {treeNode} 匹配的子项
     */
	findChild: function (attribute, value, deep) {
		let newCurrent = this.tree.state.keysTreeNode[this.itemData[this.tree.state.key]];
		let me = this;
		if (newCurrent) {
			me = newCurrent.props;
		}
		return me.findChildBy(function () {
			return this[attribute] == value;
		}, null, deep);
	},
    /**
     * 通过自定义函数查找第一个子项。 如果传递的函数返回true，则该子项匹配。
     * @param  {Function} fn    [如果通过的节点是所需的节点，fn一个必须返回true的函数。]
     * @param  {[Object]}   scope [执行该函数的作用域（此引用）。 默认为正在测试的节点。]
     * @param  {[Boolean]}   deep = false  [true：搜索比直接子节点更深的节点]
     * @return {[type]}         [找到的子元素，如果没有找到，则返回null]
	 * 
	 * @private
     */
	findChildBy: function (fn, scope, deep) {
		var cs = [];
		if (this.children) {
			cs = this.children;
		}
		var len = cs.length,
			i = 0,
			n, res;
		for (; i < len; i++) {
			n = cs[i].props;
			if (fn.call(scope || n.itemData, n.itemData) === true) {
				return n;
			} else if (deep) {
				res = n.findChildBy(fn, scope, deep);
				if (res !== null) {
					return res;
				}
			}
		}
		return null;
	},
    /**
    * 展开当前节点
    */
	expand: function () {
		if (!this || !this.itemData[this.tree.state.key]) return;
		// this.tree.state.expandedKeys.push(this.itemData[this.tree.state.key]);
		// this.tree.setState({ loading: true });
		let key = this.itemData[this.tree.state.key];
		let expandedKeys = [...this.tree.state.expandedKeys];
		if (expandedKeys.indexOf(key) < 0) {
			expandedKeys.push(key);
			this.tree.setState({ expandedKeys });
		}
	},
    /**
     * 取得节点的GUID，从根节点开始的节点编码拼接
	 * @returns {string} guid
     */
	getGUID: function () {
		if (this.isRoot()) {
			return this.gainGUID();
		}
		let root = this.gainRoot();
		let mid = this.getMID();
		let guid;
		if (mid) {
			guid = root.gainGUID() + "`" + mid;
		} else {
			guid = root.gainGUID();
		}
		return guid;
	},
    /**
     * 取得获得成员编号,它是由除了根节点之外,各层节点SC的组装串
	 * @returns {string} mid字符串
	 * 
	 * @private
     */
	getMID: function () {
		let rec = this.getData() || {};
		let mid = rec.sc || "";

		let p = this.gainParent();
		if (!p || p.isRoot()) return mid; //父节点存在且不是根，才会往下走

		let pmid = p.getMID();
		if (pmid) mid = pmid + "`" + mid;

		return mid;
	},
    /**
     * 获取当前节点的GUID
	 * @returns {string} guid字符串
     */
	gainGUID: function () {
		let rec = this.getData() || {};
		let guid = rec.ap + "_" + rec.tt + "_" + rec.ss + "_" + rec.sc;
		return guid;
	},
}

export { sgiTreeBaseFun, sgiTreeNodeFun }



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTreeBaseFun.js